//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            tableData:[],
            pgData:{
                isMore:false
            }
        }
    },
    methods:{
        showMore(){
            this.$refs.page.reload();
        },
        download(row){
            this.$get(this.getStore('bankguart') + '/gua_hz/'+row.id+'/download',function(data){
                window.open(data);
            })
        },
        del(row){
            var that = this;
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$ajax({
                    type:'delete',
                    url:that.getStore('bankguart') + '/gua_hz/'+row.id,
                    callback:function(data){
                        that.$notify({
                            title: '成功',
                            message: '删除成功',
                            type: 'success'
                        });
                        that.$emit('close');
                        that.$refs.page.reload();
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        }
    },
    mounted(){

    }
}
